<template>
  <aside id="capustaSlider" @click.self="CLOSE_TRANSACTION">
    <transition :name="slideName" mode="out-in">
      <TransactionInfo
        :key="SELECTED_TRANSACTION.owner_id"
        v-hammer:pan="onSwipe"
        :transaction="SELECTED_TRANSACTION"
      />
    </transition>
  </aside>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import TransactionInfo from '@/components/main/TransactionInfo';

function getDirection(num) {
  switch (num) {
    case 2:
      return 'left';
    case 8:
      return 'top';
    case 4:
      return 'right';
    case 16:
      return 'down';
  }
}

export default {
  components: {
    TransactionInfo,
  },
  data() {
    return {
      slideName: 'slide-left',
    };
  },
  computed: {
    currentIndex() {
      return this.TRANSACTIONS.result.findIndex(el => el.owner_id === this.SELECTED_TRANSACTION.owner_id);
    },
    prevExists() {
      return this.currentIndex >= 0 && this.TRANSACTIONS.result[this.currentIndex - 1];
    },
    nextExists() {
      return this.currentIndex >= 0 && this.TRANSACTIONS.result[this.currentIndex + 1];
    },
    ...mapState(['SELECTED_TRANSACTION', 'TRANSACTIONS']),
    ...mapGetters(['isDesktop']),
  },
  watch: {
    SELECTED_TRANSACTION(next, prev) {
      if (!prev.owner_id) {
        this.slideName = 'slide-left';
        return;
      }

      let prevIndex = this.TRANSACTIONS.result.findIndex(el => el.owner_id === prev.owner_id);
      let nextIndex = this.TRANSACTIONS.result.findIndex(el => el.owner_id === next.owner_id);

      this.slideName = prevIndex < nextIndex ? 'slide-left' : 'slide-right';
    },
  },
  methods: {
    onSwipe(event) {
      const direction = getDirection(event.direction);

      switch (direction) {
        case 'left':
          this.swipeOnRight();
          return;
        case 'right':
          this.swipeOnLeft();
          return;
        // case 'down':
        //   this.swipeOnDown();
        //   return;
      }
    },
    swipeOnLeft() {
      if (!this.prevExists) {
        return;
      }

      this.SELECT_TRANSACTION(this.TRANSACTIONS.result[this.currentIndex - 1]);
    },
    swipeOnRight() {
      if (!this.nextExists) {
        return;
      }

      this.SELECT_TRANSACTION(this.TRANSACTIONS.result[this.currentIndex + 1]);
    },
    swipeOnDown() {
      this.CLOSE_TRANSACTION();
    },
    ...mapMutations(['SELECT_TRANSACTION', 'CLOSE_TRANSACTION']),
  },
};
</script>

<style lang="sass" scoped>
  #capustaSlider
    +full-size(0, fixed)
    +square-box(100%)
    background: rgba(30, 28, 47, 0.55)
    z-index: 100
</style>
